// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".music_list_wrapper[data-v-11f14428]{position:relative;padding:0 .12rem .24rem}.music_list_wrapper h2[data-v-11f14428]{margin:.28rem 0;font-size:.32rem;width:100%;text-align:center}", ""]);
// Exports
module.exports = exports;
